module.exports = "img/flags/MD.1abb1cc.png";